import { useApi } from '@/shared/api/http';

export const useCartService = () => {
  const api = useApi();

  const getCart = async (isAuth = true) => {
    try {
      return await api.get<any>('/cart/', isAuth);
    } catch (error) {
      console.error('Ошибка при получении корзины:', error);
      throw error;
    }
  };

  const addToCart = async (productId: string, isAuth = true) => {
    try {
      return await api.post<any>(`/cart/add/${productId}/`, isAuth);
    } catch (error) {
      console.error('Ошибка при добавлении в корзину:', error);
      throw error;
    }
  };

  const decrementProductAmount = async (productId: string, isAuth = true) => {
    try {
      return await api.post<any>(`/cart/decrement/${productId}/`, isAuth);
    } catch (error) {
      console.error('Ошибка при уменьшении количества товара в корзине:', error);
      throw error;
    }
  };

  const removeFromCart = async (productId: string, isAuth = true) => {
    try {
      return await api.delete<any>(`/cart/remove/${productId}/`, isAuth);
    } catch (error) {
      console.error('Ошибка при удалении товара из корзины:', error);
      throw error;
    }
  };

  const clearCart = async (isAuth = true) => {
    try {
      return await api.delete<any>(`/cart/clear/`, isAuth);
    } catch (error) {
      console.error('Ошибка при очищении корзины:', error);
      throw error;
    }
  };

  return {
    getCart,
    addToCart,
    decrementProductAmount,
    removeFromCart,
    clearCart,
  };
};
